export default "__VITE_ASSET__TttZKAImyQ5RIG6_MhVTMA__"